"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
const state_1 = require("@airstudio/state");
const react_redux_1 = require("react-redux");
const JsonViewer_1 = require("../JsonViewer");
exports.WorkspaceEditor = ({ isVisible, setIsVisible, hide, componentClass: CC }) => {
    const workspace = react_redux_1.useSelector(state_1.Selectors.Workspaces.getActiveWorkspace);
    const dispatchUpdateWorkspace = state_1.Operations.Workspaces.update(react_redux_1.useDispatch());
    const { errorMessage, isProcessing } = react_redux_1.useSelector(state_1.Selectors.Workspaces.state);
    if (!workspace) {
        return react_1.default.createElement("div", null, "Loading");
    }
    const handleSave = async () => {
        const isSuccessful = await dispatchUpdateWorkspace(workspace.id, workspace);
        if (isSuccessful) {
            setIsVisible(false);
            rsuite_1.Notification.success({ title: 'Workspace updated' });
        }
    };
    const isChildVisible = (key) => {
        if (hide && (hide.includes(key) || hide.includes('all'))) {
            return false;
        }
        return true;
    };
    return (react_1.default.createElement(rsuite_1.Modal, { size: "md", show: isVisible, onHide: () => setIsVisible(false) },
        isChildVisible('header') && (react_1.default.createElement(rsuite_1.Modal.Header, null,
            react_1.default.createElement(rsuite_1.Modal.Title, { style: { textAlign: 'center' } },
                "Workspace ",
                workspace.id))),
        react_1.default.createElement(rsuite_1.Modal.Body, null,
            errorMessage && isChildVisible('errorMessage') &&
                react_1.default.createElement(rsuite_1.Message, { description: errorMessage }),
            CC
                ? (react_1.default.createElement(CC, { workspace: workspace, errorMessage: errorMessage, isProcessing: isProcessing, handleSave: handleSave }))
                : react_1.default.createElement(JsonViewer_1.JsonViewer, { json: { workspace } })),
        isChildVisible('footer') && (react_1.default.createElement(rsuite_1.Modal.Footer, null,
            react_1.default.createElement(rsuite_1.Button, { appearance: "primary", loading: isProcessing, onClick: handleSave }, "Save")))));
};
//# sourceMappingURL=index.js.map